import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTFUNNELONBEHALFFIELDBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "on_behalf_input_type",
  "placeholder",
  "required",
  { type: 'separator' },
  "text_color",
  "color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFunnelOnBehalfFieldBlockDescriptor: _generatedKioskCartFunnelOnBehalfFieldBlockDescriptor,
  kioskCartFunnelOnBehalfFieldBlockBlocDefinition,
  kioskCartFunnelOnBehalfFieldBlockDashboardLayout,
  kioskCartFunnelOnBehalfFieldBlockConfig,
  kioskCartFunnelOnBehalfFieldBlockResolveConfig,
  kioskCartFunnelOnBehalfFieldBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart funnel / On behalf field input",
    componentType: 'KioskCartFunnelOnBehalfFieldBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart funnel / On behalf field input.",
    keywords: [],
    allowedIn: [
      { bloc: "KioskCartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.title.label",
        help: "pages.blocks.kiosk-cart-funnel-on-behalf-field.title.help",
      }
    }),
    on_behalf_input_type: propertyValue({
      type: 'select',
      value: "email",
      options: {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.on-behalf-input-type.label",
        multiple: false,
        choices: [
          {
            value: "email",
            label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.on-behalf-input-type.options.email",
          },
          {
            value: "text",
            label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.on-behalf-input-type.options.text",
          },
          {
            value: "tel",
            label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.on-behalf-input-type.options.tel",
          },
          {
            value: "checkbox",
            label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.on-behalf-input-type.options.checkbox",
          }
        ]
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.placeholder.label",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.required.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.text-color.label",
      }
    }),
    color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-funnel-on-behalf-field.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-funnel-on-behalf-field.fieldset.field.label",
            fields: [
              "title",
              "on_behalf_input_type",
              "placeholder",
              "required",
              "text_color",
              "color",
            ],
          },
        ],
      },
    ],
  })
);

export function kioskCartFunnelOnBehalfFieldBlockDescriptor(): IBlockDescriptor;
export function kioskCartFunnelOnBehalfFieldBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFunnelOnBehalfFieldBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFunnelOnBehalfFieldBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFunnelOnBehalfFieldBlockDescriptor, kioskCartFunnelOnBehalfFieldBlockProperties, fieldOrder);
}

export {
  kioskCartFunnelOnBehalfFieldBlockBlocDefinition,
  kioskCartFunnelOnBehalfFieldBlockDashboardLayout,
  kioskCartFunnelOnBehalfFieldBlockProperties,
  kioskCartFunnelOnBehalfFieldBlockConfig,
  kioskCartFunnelOnBehalfFieldBlockResolveConfig,
};

export type KioskCartFunnelOnBehalfFieldBlockConfig = typeof kioskCartFunnelOnBehalfFieldBlockConfig;
